var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "rb-fieldrow-radio",
      class: {
        "rb-disabledrow": _vm.disabled,
        "rb-fieldrow-radio__error": _vm.isInValidRow,
      },
    },
    [
      _vm.title
        ? _c("span", { staticClass: "rb-fieldrow-radio__title" }, [
            _vm._v(_vm._s(_vm.title)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.description
        ? _c("span", { staticClass: "rb-fieldrow-radio__description" }, [
            _vm._v(_vm._s(_vm.description)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.lazy",
            value: _vm.value,
            expression: "value",
            modifiers: { lazy: true },
          },
        ],
        ref: "navigationClick",
        attrs: {
          id: _vm.id,
          type: "radio",
          name: _vm.name,
          required: _vm.required,
          disabled: _vm.disabled,
          tabindex: "-1",
        },
        domProps: {
          value: _vm.radioValue,
          checked: _vm._q(_vm.value, _vm.radioValue),
        },
        on: {
          change: [
            function ($event) {
              _vm.value = _vm.radioValue
            },
            function ($event) {
              return _vm.$emit("change", $event.target.value)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "rb-fieldrow-radio__checkmark",
        class: {
          "rb-fieldrow-radio__error": _vm.isInValidRow,
        },
        attrs: { tabindex: "0" },
        on: { keypress: _vm.changeOnKeypress },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }